<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="选择待结算加工信息"
      in-dialog
      @create-opened="onCreateOpened"
      @closed="onClosed"
    >
      <template slot="form">
        
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="24">
              <div class="flex">
                <el-button type="primary" @click="query">查询</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="入库单号" prop="unit">
                <el-input v-model="queryData.DocNo" type="text" placeholder="请输入入库单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入库日期" prop="date">
                <range-picker  
                  :date="[queryData.DocDateStart, queryData.DocDateEnd]"
                  @change="x=>{queryData.DocDateStart=x.Start;queryData.DocDateEnd=x.End;}"
                  >
                </range-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
               <el-form-item label="产品名称" prop="Name">
                <el-input v-model="queryData.ProductName" placeholder="请输入产品名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
               <el-form-item label="产品编号" prop="Name">
                <el-input v-model="queryData.ProductNo" placeholder="请输入产品编号" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-table ref="table" @selection-change="x=>data.Rows1=x" :data="data.Details1" border>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="入库单号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="入库日期" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="产品编号" min-width="150">
            <template slot-scope="{row}">{{row.ProductNo}}</template>
          </el-table-column>
          <el-table-column label="产品名称" min-width="150">
            <template slot-scope="{row}">{{row.ProductName}}</template>
          </el-table-column>
          <el-table-column label="产品规格" prop="ProductSpec" min-width="100" show-overflow-tooltip />
          <el-table-column label="产品单位" prop="UnitName" min-width="90" />
          <el-table-column label="颜色" prop="ColorName" min-width="90" />
          <el-table-column label="入库数量" width="100">
            <template slot-scope="{row}">{{row.Quantity}}</template>
          </el-table-column>
        </el-table>
        <!-- <div v-if="noData" style="text-align: center;">暂无数据</div> -->
        <!-- <template v-if="data.Details1.length>0">
          <div class="row-tb-head">
            <span>注塑委外入库信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows1=x" :data="data.Details1" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="入库单号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="入库日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="入库数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details2.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>胶件加工入库信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows2=x" :data="data.Details2" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="入库单号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="入库日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="入库数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details3.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>配件装配入库信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows3=x" :data="data.Details3" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="入库单号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="入库日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="入库数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details4.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>产品装配入库信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows4=x" :data="data.Details4" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="入库单号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="入库日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="入库数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details5.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>注塑委外报工信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows5=x" :data="data.Details5" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="工序" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="报工数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details6.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>胶件委外报工信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows6=x" :data="data.Details6" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="工序" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="报工数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details7.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>配件装配委外报工信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows7=x" :data="data.Details7" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="工序" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="报工数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.Details8.length>0">
          <div class="row-tb-head" style="margin-top: 10px;">
            <span>产品装配委外报工信息</span>
          </div>
          <el-table ref="table" @selection-change="x=>Rows8=x" :data="data.Details8" border>
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="工单编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="工序" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="物料编号" min-width="150">
              <template slot-scope="{row}">{{row.MaterialNo}}</template>
            </el-table-column>
            <el-table-column label="报工数量" min-width="100">
              <template slot-scope="{row}">{{row.Quantity}}</template>
            </el-table-column>
          </el-table>
        </template>-->
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/rp/woDoc").default,
      in_api: require("@/api/st/productInDts").default,
      queryData: {
        DocNo: "",
        DocDateStart: "",
        DocDateEnd: "",
        ProductNo: "",
        ProductName: "",
        ToCost: true,
        ProductionDpId: 0,

      },
      data: {
        Details1: [],
        Rows1: [],
        Details2: [],
        Rows2: [],
        Details3: [],
        Rows3: [],
        Details4: [],
        Rows4: [],
        Details5: [],
        Rows5: [],
        Details6: [],
        Rows6: [],
        Details7: [],
        Rows7: [],
        Details8: [],
        Rows8: [],
      },
    };
  },
  computed: {
    noData() {
      return this.data.Details1.length == 0;
      // return (
      //   this.data.Details1.length == 0 &&
      //   this.data.Details2.length == 0 &&
      //   this.data.Details3.length == 0 &&
      //   this.data.Details4.length == 0
      // );
    },
  },
  methods: {
  query(){
    let params = this.queryData;
    this.in_api.list(params).then((res) => {
      console.log("res", res);
      this.data.Details1 = res.Data;
    });
  },
  onCreateOpened(data) {
      console.log("添加", this.$commonJs.toJson(data));
      this.queryData.ProductionDpId = data.TradeUnitId;
      var params = { ProductionDpId: data.TradeUnitId, ToCost: true };
      this.in_api.list(params).then((res) => {
        console.log("res", res);
        this.data.Details1 = res.Data;
      });
    },
    save() {
      console.log("保存", this.data);
      var rows = this.data.Rows1;
      if (rows.length != 0) {
        this.$emit("select", rows);
        this.close(true);
      } else {
        this.$message.warning("请选择数据");
      }
    },
    onClosed() {
      this.data.Details1 = [];
      this.data.Rows1 = [];
    },
  },
};
</script> 

<style lang="scss" scoped>
.flex{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
}
</style>